<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">二维码组队</div>
      <div class="sub-title">他人扫码即可成为你的队员</div>
      <div class="qrcode"><img width="110" height="110" :src="qrcode_url" alt="我是二维码"></div>
      <div class="qrcode-copy-content" id="qrcode-copy-content"></div>
      <div class="desc">长按保存二维码</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 276px;
    padding: 30px 42px;
    text-align: center;
    position: relative;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .qrcode {
      width: 110px;
      height: 110px;
      background-color: #fff;
      margin: 0 auto 5px;
      position: relative;

      img {
        pointer-events: auto;
      }
    }

    .qrcode-copy-content {
      z-index: 10;
      position: absolute;
      top: 113px;
      left: 93px;
    }

    .desc {
      font-size: 13px;
      color: #B5B5B5;

      @include regular();
    }
  }
</style>
<script>
import { mapState } from 'vuex'
import Dialog from 'components/Dialog'
export default {
  components: {
    Dialog
  },
  computed: {
    ...mapState({
      qrcode_url: state => state.user.qrcode_url
    })
  },
  mounted () {
    $bus.$on('showQrcode', (e) => {
      this.show()
    })
  },
  destroyed () {
    $bus.$off('showQrcode')
  },
  methods: {
    embeddedCanvasImage () {
      let c = document.getElementById('qrcode-content')
      let ctx = c.getContext('2d')
      let bg = new Image()
      bg.src = this.qrcode_url
      bg.onload = () => {
        // 先填充白色
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, 110, 110)
        // 二维码
        ctx.drawImage(bg, 0, 0, 110, 110)

        let t = document.getElementById('qrcode-copy-content')
        let img = document.createElement('img')
        img.src = c.toDataURL()
        img.style.pointerEvents = 'auto'
        t.appendChild(img)
      }
    },
    show () {
      // this.clear()
      this.$refs.p.show()
      // this.embeddedCanvasImage()
    },
    hide () {
      this.$refs.p.hide()
    },
    clear () {
      let t = document.getElementById('qrcode-copy-content')
      let first_img = t.getElementsByTagName('img')[0]
      if (first_img) {
        t.removeChild(first_img)
      }
    }
  }
}
</script>
